'use client';

import React from 'react';

// 레이아웃 컴포넌트 타입
interface LayoutProps {
  children: React.ReactNode;
  meta?: {
    title?: string;
    description?: string;
    cover?: string | null;
  };
}

export default function NotionPureLayout({ children }: LayoutProps) {
  return <div className="relative bg-white">{children}</div>;
}
